import { render } from "./LogoWithMessage.vue?vue&type=template&id=12afe0ff&scoped=true"
import script from "./LogoWithMessage.vue?vue&type=script&lang=js"
export * from "./LogoWithMessage.vue?vue&type=script&lang=js"

import "./LogoWithMessage.vue?vue&type=style&index=0&id=12afe0ff&scoped=scoped&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12afe0ff"]])

export default __exports__